export default __webpack_public_path__ + "static/media/bebek-icon.94dddd0f.svg";